import React from "react";

const Survey = () => {
  return (
    <div className="page">
      <section className="survey-page">
        <h1  style={{ color: "#184080"}}>Drivve&trade; Feedback</h1>
        <p  style={{ color: "#130F0F",fontSize:"16px"}}>Your feedback helps us improve Drivve&trade;.</p>

       <form
  name="drivve-feedback"
  method="POST"
  action="/"
  data-netlify="true"
  netlify-honeypot="bot-field"
  className="survey-form"
>

          {/* REQUIRED hidden input for Netlify */}
          <input type="hidden" name="form-name" value="drivve-feedback" />

          {/* Anti-spam */}
          <p hidden>
            <label>
              Don’t fill this out: <input name="bot-field" />
            </label>
          </p>

          {/* NAME */}
        <label style={{ color: "#130F0F", fontSize: "16px" }}>
  Full Name
  <input
    type="text"
    name="name"
    placeholder="Enter your full name"
    required
    minLength="2"
    pattern="^[A-Za-z ]+$"
    title="Name should contain only letters"
    onInput={(e) => {
      // Remove numbers & symbols while typing
      let value = e.target.value.replace(/[^A-Za-z ]/g, "");

      // Prevent multiple spaces
      value = value.replace(/\s{2,}/g, " ");

      e.target.value = value;

      // Custom validation
      if (value.trim().length < 2) {
        e.target.setCustomValidity("Please enter your full name");
      } else {
        e.target.setCustomValidity("");
      }
    }}
  />
</label>

<label style={{ color: "#130F0F", fontSize: "16px" }}>
  City
  <input
    type="text"
    name="city"
    placeholder="Your city"
    required
    pattern="^[A-Za-z ]+$"
    title="City should contain only letters"
    onInput={(e) => {
      e.target.value = e.target.value.replace(/[^A-Za-z ]/g, "");
    }}
  />
</label>


         

         <label style={{ color: "#130F0F", fontSize: "16px" }}>
  Phone Number
  <input
    type="tel"
    name="phone"
    placeholder="10-digit mobile number"
    inputMode="numeric"
    maxLength="10"
    required
    onInput={(e) => {
      let value = e.target.value.replace(/\D/g, "");

      // ✅ Block invalid starting digits
      if (value.length === 1 && !/[6-9]/.test(value)) {
        value = "";
      }

      e.target.value = value;

      // ✅ Custom validation message
      if (!/^[6-9]\d{9}$/.test(value)) {
        e.target.setCustomValidity(
          "Enter a valid Indian number starting with 6-9"
        );
      } else {
        e.target.setCustomValidity("");
      }
    }}
  />
</label>


          {/* FEEDBACK */}
          <label style={{ color: "#130F0F",fontSize:"16px"}}>
            Your Feedback
            <textarea
              name="feedback"
              placeholder="Share your thoughts or suggestions"
              rows="4"
              required
            />
          </label>

          <button type="submit" className="btn btn-primary">
            Submit Feedback
          </button>
        </form>
      </section>
    </div>
  );
};

export default Survey;
